import { Reveal, SectionTitle } from "./Reveal";
import { useT } from "../../i18n/LangContext";

export const Steps = () => {
  const t = useT().how;
  return (
    <section id="how-it-works" className="scroll-mt-16 bg-white px-5 py-16 sm:px-8 lg:py-20" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionTitle>{t.title}</SectionTitle>
        </Reveal>
        <ol className="mt-8 grid gap-4 md:grid-cols-3">
          {t.appSteps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className="h-full">
              <li className="h-full rounded-xl bg-[#F3F3F3] p-6" data-testid={`step-${i + 1}`}>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#FFD000] text-sm font-bold text-black">{i + 1}</span>
                <h3 className="mt-6 text-lg font-bold text-black">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-600 sm:text-base">{s.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
